export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-linkedin-ff5923269f4c9b75f97883f4c2b0b4fb.svg";